import { initGlobalState } from 'qiankun';
// 初始化 state
let state = { 
	currentOnlineChatStatus: 121,
	onGlobalStateChange: 'test',

  changeWorkbenchStatus: 'wait', // 用来监听子系统开始工作时与基座系统传递约定状态的参数值，只支持子系统开始工作
} 
const actions = initGlobalState(state);

export default actions;